import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor() { 
    
  }

  ngOnInit() {
    if ((localStorage.fixedfooter && localStorage.fixedfooter == "on")) {
      let element = document.getElementsByClassName('footer');
      if (element.length > 0) {
        element[0].setAttribute('class', 'footer fixed');
      } else
        element[0].setAttribute('class', 'footer');

    }
  }



}
